import { render, staticRenderFns } from "./EditPostCategoriesModal.vue?vue&type=template&id=566e0657&scoped=true&"
import script from "./EditPostCategoriesModal.vue?vue&type=script&lang=js&"
export * from "./EditPostCategoriesModal.vue?vue&type=script&lang=js&"
import style0 from "./EditPostCategoriesModal.vue?vue&type=style&index=0&id=566e0657&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566e0657",
  null
  
)

export default component.exports